import axios from 'axios';
import { PremiumPlanData, PremiumTemplateData } from '../store/premium/reducer';
import { PremiumProduct } from '../components/Shops/Premium/interfaces/PremiumProduct';

export const premiumInfoRequest = (tipster_id: string) =>
  axios.get(`/v1/premium/tipsters/${tipster_id}/plans`);

export const publicPremiumInfoRequest = async (data: any) => {
  const { tipster_id } = data;
  const premiumPlansResponse = (await axios.get(
    `/v1/premium/tipsters/${tipster_id}/plans/public`,
  )) as unknown as {
    templates: PremiumTemplateData[];
    tipster_premium_plans: PremiumPlanData[];
  };

  const filteredPremiumPlans: PremiumProduct[] =
    premiumPlansResponse.tipster_premium_plans.reduce(
      (accumulator: any, premiumPlan: PremiumPlanData) => {
        if (premiumPlan.active) {
          const templateByID = premiumPlansResponse.templates.find(
            (template: PremiumTemplateData) =>
              template.id === premiumPlan.plan_template_id,
          );

          accumulator.push(new PremiumProduct(premiumPlan, templateByID!));

          return accumulator;
        }

        return accumulator;
      },
      [],
    );
  if (filteredPremiumPlans.length === 0) {
    throw new Error('no active plans');
  }

  return filteredPremiumPlans.sort(function (a, b) {
    const a_price = a.price.amount || 0;
    const b_price = b.price.amount || 1;
    if (a_price > b_price) {
      return 1;
    }
    if (a_price < b_price) {
      return -1;
    }
    return 0;
  });
};

export const getPremiumPricingTiers = () =>
  axios.get('v1/pricing/premium/tiers');
